import { Component, Input, Output, EventEmitter, inject, OnInit, AfterViewInit, signal } from '@angular/core';
import { FormGroup, FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { ViewNewRepApplication } from '../../new-rep-application-interfaces/viewnew-rep-application.interface';

@Component({
  selector: 'app-additional-declarations',
  imports: [
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatIcon
  ],
  templateUrl: './additional-declarations.component.html',
  styleUrl: './additional-declarations.component.scss'
})
export class AdditionalDeclarationsComponent implements OnInit {
  @Output() next = new EventEmitter<string[]>();
  @Input() formGroup!: FormGroup;
  @Input() additionalDeclarations!: ViewNewRepApplication;
  @Input() readonly = signal(false);
  status = 'Not Started';

  private fb = inject(FormBuilder);

  async ngOnInit() {
    this.formGroup.addControl('details', this.fb.control(''));
    await this.fetchAdditionalDeclarations();
    this.handleFormStatus();
  }

  handleFormStatus() {
    if (this.readonly()) return;

    const initialValue = this.formGroup.getRawValue();

    this.formGroup.valueChanges.subscribe(currentValue => {
      const hasChanged =
        JSON.stringify(initialValue) !== JSON.stringify(currentValue);

      if (hasChanged) {
        this.status = 'In Progress';
        this.next.emit([this.status, 'change']);
      }
    });
  }

  fetchAdditionalDeclarations(): void {
    this.formGroup.controls['details']?.setValue(this.additionalDeclarations?.declarationComment);
    if (this.formGroup.valid) {
      const anyFilled = Object.values(this.formGroup.value).some(v => v && v.toString().trim() !== '');
      if (anyFilled) {
        this.status = 'Completed';
        this.next.emit([this.status, 'submitted']);
      } else {
        if (this.readonly() == true) {
          this.status = 'Completed';
          this.next.emit([this.status, 'submitted']);
        } else {
          this.status = 'Not Started';
          this.next.emit([this.status, 'submitted']);
        }
      }

    }
    if (this.readonly() == true) {
      this.formGroup?.disable();
    } else {
      this.formGroup?.enable();
    }
  }

  saveAndContinue() {

    // Save API call or form validation here
    if (this.formGroup.valid) {
      this.status = 'Completed';

    } else {
      this.status = 'In Progress';
    }
    this.formGroup.markAllAsTouched();
    this.next.emit([this.status, 'submit']);
  }
}
